import { render, staticRenderFns } from "./ButtonTop.vue?vue&type=template&id=f234e016&scoped=true"
import script from "./ButtonTop.vue?vue&type=script&lang=js"
export * from "./ButtonTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f234e016",
  null
  
)

export default component.exports